/**
 * External dependencies:
 */
import React, { useCallback } from "react";
import Deliveries from "@/frontend/domain/cart/components/deliveries";

const CartRow = ({
    item,
    onDelete,
    onDeliveryChange,
    onQuantityChange,
}) => {
    const onDeleteClick = useCallback(
        (event) => {
            event.preventDefault();
            if (onDelete) {
                onDelete(item);
            }
        },
        [onDelete, item],
    );

    const onChange = useCallback(
        (event) => {
            if (onQuantityChange) {
                onQuantityChange(event.target.value, item);
            }
        },
        [onQuantityChange, item],
    );

    const handleDeliveryChange = useCallback(
        (enabled, id) => {
            onDeliveryChange(item, enabled, id);
        },
        [onDeliveryChange, item],
    );

    return (
        <div className="cart__row">
            <div className="cart__col size--2of5">
                <div className="cart__head--mobile">
                    <h6>Item</h6>
                </div>

                <div className="cart__item">
                    <div className="cart__image">
                        <img
                            src={item.product.image}
                            alt=""
                            width="116"
                            height="148"
                        />
                    </div>

                    <div className="cart__name">
                        <h5>{item.product.business}</h5>
                        <h5>{item.product.name}</h5>

                        <div className="checkbox">
                            <input
                                type="checkbox"
                                name="field-checkbox-cart1#"
                                id="field-checkbox-cart1#"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="cart__col size--1of5">
                <div className="cart__head--mobile">
                    <h6>Quantity</h6>
                </div>

                <div className="cart__number">
                    <div className="quantity cart__quantity">
                        <label
                            htmlFor="quantity"
                            className="quantity__label hidden"
                        >
                            Quantity
                        </label>

                        <input
                            type="number"
                            className="field quantity__field"
                            name="quantity"
                            value={item.count}
                            onChange={onChange}
                            min={1}
                        />

                        <div className="cart__delete">
                            <a
                                className="link-more link-more--xs"
                                onClick={onDeleteClick}
                            >
                                Remove Item
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div className="cart__col size--1of5">
                <div className="cart__head--mobile">
                    <h6>Delivery</h6>
                </div>

                <div className="cart__delivery">
                    <Deliveries
                        name={`delivery_${item.productId}`}
                        delivery={item.deliveryId}
                        deliveries={item.product.deliveries}
                        onChange={handleDeliveryChange}
                    />
                </div>
            </div>

            <div className="cart__col size--1of5">
                <div className="cart__head--mobile">
                    <h6>Price</h6>
                </div>

                <div className="cart__price">
                    <div className="cart__price-row">
                        <p className="price price--right">
                            {item.product.retailValue ? (
                                <span className="price__old">
                                    ${item.product.retailValue}
                                </span>
                            ) : null}
                            <span className="price__new">
                                ${item.product.price}
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CartRow;
